<template>
  <div class="container">
    <!-- 保修列表 -->
    <div class="scroll-y">
      <div
        class="plbm-list"
        v-for="item in problemList"
        :key="item.maintenanceFormId"
        @click="handleGopageDetails(item.maintenanceFormId)"
      >
        <div class="plbm-list-type">
          报修类型：{{ item.maintenanceType }}
          <span
            class="plbm-list-status red-color clearfix"
            v-if="item.maintenanceStatus == 0"
            >待处理</span
          >
          <span
            class="plbm-list-status gray-color clearfix"
            v-if="item.maintenanceStatus == 1"
            >处理中</span
          >
          <span
            class="plbm-list-status yellow-color clearfix"
            v-if="item.maintenanceStatus == 2"
            >已关闭</span
          >
          <span
            class="plbm-list-status blue-color clearfix"
            v-if="item.maintenanceStatus == 3"
            >处理完毕</span
          >
        </div>
        <div class="plbm-list-time">申请时间：{{ item.applyDate }}</div>
      </div>
    </div>
    <!-- 保修按钮 -->
    <div class="plbm-btn" @click="handleGopageClick">我要报修</div>
  </div>
</template>
<script>
import { PblmWarrantyList } from "@/api/warranty";
export default {
  data() {
    return {
      problemList: [],
    };
  },
  mounted() {
    this.requestPblmWarrantyList();
    console.log(location.href.split("#")[1]);
  },
  methods: {
    // 检测距离底部的距离
    getScroll(event) {
      console.log(event);
      let scrollBottom =
        event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight;
      console.log(scrollBottom);
      //  124
      if (scrollBottom) {
      }
    },
    //  保修问题列表
    requestPblmWarrantyList() {
      console.log(this.$cookies.get("internetBarId"));
      var internetBarIds = this.$cookies.get("internetBarId");
      var internetBarId = null;
      if (
        internetBarIds != null &&
        internetBarIds != undefined &&
        internetBarIds.length != 0
      ) {
        internetBarId = internetBarIds;
      } else {
        internetBarId = sessionStorage.getItem("internetBarId");
      }
      PblmWarrantyList({ internetBarId: internetBarId }).then((res) => {
        console.log(res);
        this.problemList = res.data.list;
      });
    },
    //  跳转详情列表
    handleGopageDetails(maintenanceFormId) {
      this.$router.push({
        path: "/detailswarranty",
        query: { maintenanceFormId: maintenanceFormId },
      });
    },
    //  跳转保修页面
    handleGopageClick() {
      this.$router.push({ path: "/writewarranty" });
    },
  },
};
</script>
<style lang="scss" scoped>
// $percentage
// 状态颜色处理
html,
body {
  background-color: #f6f6f6 !important;
}
.red-color {
  color: #ff3838;
}
.gray-color {
  color: #999999;
}
.yellow-color {
  color: #ffaa00;
}
.blue-color {
  color: #008cff;
}

.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  // 列表内容
  .scroll-y {
    width: 100%;
    height: 89%;
    background-color: #f6f6f6;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .plbm-list {
    width: 350px;
    height: 80px;
    background-color: $white-color;
    margin: 10px 13px;
    border-radius: 8px;
    font-size: 14px;
    text-align: left;
    .plbm-list-type {
      padding: 15px 15px;
      box-sizing: border-box;
      .plbm-list-status {
        text-align: right;
        float: right;
      }
    }
    .plbm-list-time {
      padding: 3px 15px;
      box-sizing: border-box;
    }
  }
  // .block {
  //     width: 100%;
  //     height: 100px;
  //     background-color: #999999
  // }
  // 按钮
  .plbm-btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    position: fixed;
    bottom: 20px;
    left: 50%;
    margin-left: -175px;
  }
}
</style>
